import { css } from '@emotion/react'
import DragIndicatorIcon from '@mui/icons-material/DragIndicator'
import { memo } from 'react'
import { getThemeSpacing } from '../styles/appTheme'
import { palette } from '../styles/colors'
import layers from '../styles/layers'
import { PAPER_HEIGHTS } from '../theme'
import IconButton from './IconButton'

const dragButtonStyles = css({
    borderRadius: 0,
    boxShadow: layers.one, //'rgb(85, 85, 85) 2px 2px 6px -4px',
    borderBottomRightRadius: getThemeSpacing(0.5),
    borderTopRightRadius: getThemeSpacing(0.5),
    border: '1px solid ' + palette.layerBorder,
    padding: `${getThemeSpacing(0.5)} 0`,
    position: 'absolute',
    cursor: 'col-resize',
    background: palette.drag,
    top: '45%',
    left: -1,
    zIndex: PAPER_HEIGHTS.closeButton,
    '&:hover': {
        background: palette.drag,
    },
})

const buttonDisplay = css({
    display: 'none',
})

interface ButtonVideoDragProps {
    hide?: boolean
    top?: number | string
    ref?: any
}

const ButtonVideoDrag = memo((props: ButtonVideoDragProps) => {
    const { hide, top, ref } = props
    const buttonTop = typeof top !== 'undefined' ? { top } : undefined
    return (
        <IconButton
            css={[dragButtonStyles, hide ? buttonDisplay : undefined]}
            style={buttonTop}
            ref={ref}
            data-testid="IconButton__VideoDrag"
        >
            <DragIndicatorIcon />
        </IconButton>
    )
})

export default ButtonVideoDrag
